var advance = function advance() {
  if(typeof quickAddButton == 'function'){
    quickAddButton();
  }
  if(document.querySelector(".random-nav")){
    var ul = document.querySelector(".random-nav");
    var items = Array.from(ul.querySelectorAll("li"));
    if(items.length > 3){
      items.sort(function() { return 0.5 - Math.random(); });
      ul.innerHTML = '';
      items.slice(0, 3).forEach(function(item) {
        ul.appendChild(item);
      });
    }
  }
}
var infinitescroll = {
  scolljs: function(){
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      // loadingText: document.getElementById('AjaxinatePagination').dataset.text,
      callback: advance,
      offset: 1000
    });
  }
}
infinitescroll.scolljs();
document.addEventListener('scroll', function(e) {
  var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
  sessionStorage.scrollPos = document.documentElement.scrollTop;
  sessionStorage.totalpage = totalpage;
});
if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
  var scrollTop=sessionStorage?.getItem('scrollPos')
  document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
  window.scrollTo(0,0);
  scrollManualy(scrollTop);
  function scrollManualy(scrollTop){
    scrollTop = parseInt(scrollTop);
    window.scrollTo(0,scrollTop)
    setTimeout(function(){
      if(window.scrollY < scrollTop){
        scrollManualy(scrollTop)
      }
    },1000);
  }
}
document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelector('.coll-desc-read')) document.querySelector('.coll-desc-read').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.coll-desc').classList.toggle('active-full-desc');
    if(document.querySelector('.coll-desc').classList.contains('active-full-desc')){
      document.querySelector('.coll-desc-wrap').style.maxHeight = document.querySelector('.coll-desc-inr').offsetHeight+'px';
    }else{
      document.querySelector('.coll-desc-wrap').style.maxHeight = '';
    }
  });
  let filterWrap = document.querySelector('.filter-wrap');
  filterWrap.addEventListener('scroll', () => {
    let scrollLeft = filterWrap.scrollLeft;
    let scrollWidth = filterWrap.scrollWidth;
    let clientWidth = filterWrap.clientWidth;
    if(scrollLeft > 0){
      filterWrap.classList.add('scrolled');
    }else{
      filterWrap.classList.remove('scrolled');
    }
    if(scrollLeft + clientWidth >= scrollWidth){
      filterWrap.classList.add('end-reached');
    }else{
      filterWrap.classList.remove('end-reached');
    }
  });
});
var lastscroll = 0;
window.addEventListener("scroll", () => {
  let scrollcount = window.pageYOffset;
  let header = document.querySelector('.main-header').clientHeight;
  let collFilter;
  if(document.querySelector('.section-collection')){
    collFilter = (document.querySelector('.section-collection').offsetTop + 6) - header;
  }else{
    collFilter = (document.querySelector('.section-main-search').offsetTop + 6) - header;
  }
  let minus = (((scrollcount - collFilter) - header) + header);
  (scrollcount >= collFilter) ? document.querySelector('body').classList.add("filter-sticky") : document.querySelector('body').classList.remove("filter-sticky")
  setTimeout(function(){
    if(scrollcount > lastscroll){
      document.querySelector('.snippet-collection-filter').style.top = '-1px';
      document.querySelector('.sort-box').style.top = '-1px';
    }else if(scrollcount < lastscroll){
      document.querySelector('.snippet-collection-filter').style.top = header+'px';
      document.querySelector('.sort-box').style.top = header+'px';
    }
    lastscroll = scrollcount;
  }, 100);
  // if(scrollcount >= collFilter){
  //   console.log(header,'header',minus,'minus');
  //   if(header > minus){
  //     if(document.querySelector('body').classList.contains('scroll-down')){
  //       document.querySelector('.main-header').classList.remove('sticky_header');
  //       document.querySelector('.main-header').style.top = -minus+'px';
  //     }
  //   }else{
  //     if(document.querySelector('body').classList.contains('scroll-up')){
  //       document.querySelector('.main-header').classList.add('sticky_header');
  //       document.querySelector('.main-header').style.top = '0px';
  //     }else{
  //       if(document.querySelector('body').classList.contains('scroll-up')){
  //         document.querySelector('.scroll-up .main-header').style.top = '0px'
  //       }else if(document.querySelector('body').classList.contains('scroll-down')){
  //         document.querySelector('.scroll-down .main-header').style.top = -header+'px';
  //       }
  //     }
  //   }
  // }
});

document.addEventListener('DOMContentLoaded', function () {
  const announcementBar = document.querySelector('.section-announcement-bar');
  const stickyBar = document.querySelector('.stapelkorting-sticky-bar');

  if (announcementBar && stickyBar) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Announcement bar is visible, hide the sticky bar
            stickyBar.style.transform = 'translateY(100%)';
          } else {
            // Announcement bar is not visible, show the sticky bar
            stickyBar.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.1 } // Trigger when 10% of the announcement bar is visible
    );

    observer.observe(announcementBar);
  }
});